import { apiClient } from "./apiClient";

export async function fetchEnabledReports() {
    const response = await apiClient('/api/reports/types/', {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}